module.exports = __webpack_public_path__ + "static/media/user.cb673a74.png";